// Stubbed out as the Google GenAI SDK was removed to proxy all calls through Edge Functions.
// Realtime API (Live) requires WebSockets which are not easily proxied through standard Supabase Edge Functions.

export class NatureNaniVoiceSession {
  private onError: (err: any) => void;

  constructor(
    callbacks: {
      onTranscript: (text: string, isModel: boolean) => void;
      onTurnComplete: (fullTranscript: string) => void;
      onError: (err: any) => void;
    }
  ) {
    this.onError = callbacks.onError;
  }

  async start() {
    setTimeout(() => {
      this.onError(new Error("Live Voice Consultation is temporarily disabled while we upgrade our systems to secure Edge Functions. Please use text search."));
    }, 500);
  }

  stop() {
    // No-op
  }
}